import { compose, prop } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { Dialog } from '@ezugi/primitives';

import { useIntl } from '../../../hooks/useIntl';
import { dialogActions, menuActions } from '../../../store/actions';
import { CASHIER_SOURCE } from '../../../store/constants/analytics';
import { widgetsSelector } from '../../../store/selectors';
import { lowBalanceClassName } from '../style.css';
import { closeButton, cashierButton } from './buttons';

const { cashier } = menuActions;
const { dialog } = dialogActions;

export const lowBalanceIntlKeys = {
  title: 'messages.low_balance',
  message: 'messages.low_balance_message',
  cashierLabel: 'general.cashier',
  closeLabel: 'general.close',
};

const LowBalance = (props) => {
  const { title, message, cashierLabel, closeLabel } = useIntl({
    keys: lowBalanceIntlKeys,
  });

  const dispatch = useDispatch();
  const canUseCashier = useSelector(compose(prop('cashier'), widgetsSelector));

  const removeDialog = () => dispatch(dialog.remove());
  const requestCashier = () => dispatch(cashier.request({ source: CASHIER_SOURCE.LOW_BALANCE }));

  return (
    <Dialog
      {...props}
      on={true}
    >
      <Dialog.Wrapper>
        <Dialog.Title>
          {title}
        </Dialog.Title>
        <Dialog.Description>
          {message}
        </Dialog.Description>
        <Dialog.Buttons>
          <Dialog.Button
            {...closeButton}
            label={closeLabel}
            className={lowBalanceClassName}
            onClick={() => removeDialog()}
          />
          {canUseCashier && (
            <Dialog.Button
              {...cashierButton}
              label={cashierLabel}
              className={lowBalanceClassName}
              onClick={() => {
                removeDialog();
                requestCashier();
              }}
            />
          )}
        </Dialog.Buttons>
      </Dialog.Wrapper>
    </Dialog>
  );
};

export default LowBalance;
